import { ReactNode } from 'react'

import {
  formControlLabelClasses,
  radioClasses,
  svgIconClasses,
  styled,
  FormControl as MuiFormControl,
} from '@mui/material'

export const RadioFormControl = styled(MuiFormControl)<{ error?: ReactNode }>(({ error, theme }) => ({
  [`& .${formControlLabelClasses.root}`]: {
    width: '100%',
  },

  [`& .${formControlLabelClasses.label}`]: {
    color: error ? theme.palette.error[500] : theme.palette.grey[800],
  },

  [`& .${radioClasses.root} .${svgIconClasses.root}`]: {
    color: error ? theme.palette.error[500] : 'currentColor',
  },
}))
